export default {
	authTokenKey: "x-account-auth-token",
	activeCampaignChatAuthTokenSecretKey: "active-campaign-chat-bc3hj"
}
